import { styled } from "@mui/material"

export const Truncate = styled("div")`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
